import StoreSocialMediaForm from './StoreSocialMediaForm'

export default StoreSocialMediaForm
